import { useState, useCallback, useRef } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { useClients } from '@authifi/clique-react-ui';
import { IdentityProviderDashboard } from '@authifi/login-pages';
import type { Client } from '@authifi/clique-react-ui';

export function IdentityProvidersPage() {
  const toast = useRef<Toast>(null);
  const { data: clients, isLoading: isClientsLoading } = useClients();
  const [selectedClient, setSelectedClient] = useState<Client | null>(null);

  const handleSuccess = useCallback((message: string) => {
    toast.current?.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
  }, []);

  const handleError = useCallback((message: string) => {
    toast.current?.show({ severity: 'error', summary: 'Error', detail: message, life: 5000 });
  }, []);

  return (
    <div>
      <Toast ref={toast} />
      <h2 className="text-2xl font-semibold text-[var(--clique-fg)] mb-2">Identity Providers</h2>
      <p className="text-[var(--clique-fg-muted)] mb-6">
        Manage which identity providers are assigned to each client.
      </p>

      <div className="flex flex-col gap-1.5 max-w-md mb-6">
        <label htmlFor="client-select" className="text-sm font-medium text-[var(--clique-fg)]">
          Client
        </label>
        <Dropdown
          id="client-select"
          value={selectedClient}
          onChange={(e) => setSelectedClient(e.value)}
          options={clients ?? []}
          optionLabel="name"
          placeholder={isClientsLoading ? 'Loading clients...' : 'Select a client'}
          filter
          showClear
          className="w-full"
          loading={isClientsLoading}
        />
      </div>

      {selectedClient ? (
        <IdentityProviderDashboard
          clientId={selectedClient.id}
          onSuccess={handleSuccess}
          onError={handleError}
        />
      ) : (
        <div className="text-center py-12 text-[var(--clique-fg-muted)]">
          <i
            aria-hidden="true"
            className="pi pi-arrow-up text-4xl text-[var(--clique-fg-tertiary)] mb-3 block"
          />
          <p>Select a client above to view its identity providers.</p>
        </div>
      )}
    </div>
  );
}
